import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';

export type ReviewAccountConfirmAction = 'close' | 'remove';

interface ReviewAccountConfirmModalProps {
  open: boolean;
  action: ReviewAccountConfirmAction;
  email: string;
  activeSessionCount: number;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function ReviewAccountConfirmModal({
  open,
  action,
  email,
  activeSessionCount,
  onClose,
  onConfirm,
  isLoading,
}: ReviewAccountConfirmModalProps) {
  const isRemove = action === 'remove';
  const confirmClass = isRemove
    ? 'border-pine-danger text-pine-danger hover:bg-pine-danger hover:text-white'
    : 'border-pine-ink text-pine-ink hover:bg-pine-ink hover:text-white';

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen && !isLoading) onClose();
      }}
    >
      <DialogContent data-testid="review-account-modal" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-[20px]">
            {isRemove ? 'Remove reviewer' : 'Close review window'}
          </DialogTitle>
          <DialogDescription>
            {isRemove ? 'Remove ' : 'Close the review window for '}
            <span className="font-semibold">{email}</span>? They will be signed out of{' '}
            {activeSessionCount} session(s)
            {isRemove
              ? '. The account is deleted and the email can be added again later.'
              : " and can't sign in until you open it again."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            data-testid="review-account-cancel"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-line text-pine-ink-soft hover:bg-pine-hover-button transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            data-testid="review-account-confirm"
            onClick={onConfirm}
            disabled={isLoading}
            className={`px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] transition-colors disabled:opacity-50 ${confirmClass}`}
          >
            {isLoading ? 'Saving...' : isRemove ? 'Remove reviewer' : 'Close window'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
